import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Dashboard from "./Dashboard";
import PageBreadcrumbs from "./PageBreadcrumbs";
import api from "../service/api";
import { logout } from "../reducers/authSlice";
import { setError, setSuccess, setWarning } from "../reducers/appSlice";
import Loader from "../components/Loader";

const MinimalPage = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setError(""));
    dispatch(setSuccess(""));
    dispatch(setWarning(""));

    if (!props.disableCheckAuth) {
      api
        .checkAuth()
        .then((res) => {})
        .catch((e) => dispatch(logout()));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dashboard>
      <PageBreadcrumbs data={props.breadcrumbs} />

      <Box
        sx={{
          m: {
            xs: 1,
            sm: 1,
            md: 2,
          },
        }}
      >
        {props.title ? (
          <Box pt={1} pl={2} pr={2}>
            <Typography variant="cuerpo">{props.title}</Typography>
          </Box>
        ) : (
          ""
        )}
        <Box>
        {props.loading ? <Loader /> : props.children}

        </Box>
      </Box>
    </Dashboard>
  );
};

MinimalPage.propTypes = {
  disableCheckAuth: PropTypes.bool.isRequired,
};

MinimalPage.defaultProps = {
  disableCheckAuth: false,
};

export default MinimalPage;
